import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Visit } from "./Visit.model";

export class Face extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  jsonValue!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fullName!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NavigationProperty({ TargetType: Visit })
  visits?: Visit[];

  GetType(): IEntityMetaData {
    return Face.getMetaData();
  }
}
